(() => {
 function initialize(){
  document.querySelectorAll('[data-sll-order-context]').forEach(root=>{
   if(root.dataset.ready)return;
   root.dataset.ready='true';
   let selection=null;
   try{selection=JSON.parse(sessionStorage.getItem('sll-order-selection')||'null');}catch{}
   const valid=selection&&selection.product===root.dataset.product&&Date.now()-selection.at<7200000&&selection.style&&selection.model&&selection.shapeLabel&&selection.color;
   if(!valid)return;
   root.querySelector('[data-order-details]').hidden=false;
   root.querySelector('[data-order-fallback]').hidden=true;
   const values={frame:selection.style+' · '+selection.model,shape:selection.shapeLabel,color:selection.color};
   root.querySelectorAll('[data-order-value]').forEach(element=>{element.textContent=values[element.dataset.orderValue]||'';});
   const form=document.getElementById(root.dataset.formId);
   if(!form)return;
   for(const [name,value]of Object.entries({'Frame style':selection.style,'Frame model':selection.model,'Lens shape':selection.shapeLabel,'Lens color':selection.color})){
    const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;input.dataset.sllOrderProperty='true';form.appendChild(input);
   }
  });
 }
 initialize();
 document.addEventListener('shopify:section:load',initialize);
})();